var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lolth-boolean',{attrs:{"value":_vm.mValue,"null-as-false":_vm.params.nullAsFalse}})}
var staticRenderFns = []

export { render, staticRenderFns }